import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import YouTube from 'react-youtube';
import client, { getLang, getImage } from 'utils/Contentful';

import { HFBlock } from 'components';
import {
  Case,
  Member,
} from './components';
import * as localeMap from './locale';

import {
  mapEntry,
  filterCase,
  listLocaleMap,
} from '../CasePage/helper';

import "./home-page.css";

class HomePage extends React.PureComponent {

  constructor() {
    super();
    this.state = {
      typeList: [],
      lang: {},
      images: {
        kv: [],
        method: [],
      }
    }
  }

  componentDidMount() {

    this.setLang(this.props.localeCode);
    this.setImage();

    client.getEntries({
      'limit': 500,
      'locale': this.props.localeCode,
      'order': 'fields.id',
      'content_type': 'case',
    }).then((entries) => {
      // item.fields.xxx ← 裡面包含了語系
      const { locale } = this.props;
      const list = entries.items.map(item => mapEntry({item, locale}));
      let {
        typeList,
        clientList,
      } = listLocaleMap({
        locale: locale,
        caseList: list
      });

      const caseList = filterCase({
        caseList: list,
        filter: {
          type: {list: typeList, indexList: []},
          client: {list: clientList, indexList: []},
          keyword: "",
        },
        locale,
        during: {
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection',
        },
      });

      typeList = typeList.reduce((obj, item) => ({
        ...obj,
        [item]: 0
      }), {});
      typeList = caseList.reduce((obj, item) => {
        let o = item.type.reduce((obj2, item2) => {
          return {
            ...obj2,
            [item2]: obj2[item2] ? obj2[item2] + 1: 1,
          }
        }, {});
        Object.keys(o).forEach(key => {
          typeList[key] += (o[key]);
        });
        return typeList;
      }, typeList);

      const colors = [
        "blue",
        "green",
        "yellow",
      ]

      typeList = Object.keys(typeList).map((key, i) => ({
        title: key,
        oriNumber: typeList[key],
        number: 0,
        color: colors[i]
      }));

      this.setState({ typeList });
      window.addEventListener('scroll', this.numberAnimation);

    }, (err) => {
      console.log('Something went wrong: ', err);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.localeCode !== this.props.localeCode &&
       !this.state.lang[this.props.localeCode]
    ) {
      this.setLang(this.props.localeCode);
    }
  }

  setLang = localeCode => {
    getLang(localeCode, 'Home').then(lang => {
      this.setState({
        lang: {
          ...this.state.lang,
          [localeCode]: lang
        }
      });
    });
  }

  setImage = () => {
    getImage('Home').then(({kv, method}) => {
      this.setState({
        images: {
          kv: kv.map(item => item ? item.fields.file.url : "" ),
          method: method.map(item => item ? item.fields.file.url : "" ),
        }
      });
    })
  }

  numberAnimation = (e) => {
    // console.warn(document.getElementsByTagName("body")[0].getBoundingClientRect());
    const { y } = this.caseBlock.getBoundingClientRect();
    const min = 555;
    const max = 200;
    let { typeList } = this.state;
    if(y < min && y > max) {
      typeList = typeList.map(item => ({
        ...item,
        number: ~~(item.oriNumber * Math.abs(min - y) / (min - max))
      }));
    } else if(y < max) {
      typeList = typeList.map(item => ({
        ...item,
        number: item.oriNumber
      }));
    } else {
      typeList = typeList.map(item => ({
        ...item,
        number: 0
      }));
    }
    this.setState({ typeList });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.numberAnimation);
  }

  render () {
    const { props } = this;
    let lang = localeMap[props.locale];
    lang = this.state.lang[props.localeCode];
    const { images: { kv, method } } = this.state;
    if(!lang) return null;
    return (
      <HFBlock
        className="home-page"
        {...props}
      >
        <div className="kv" style={{backgroundImage: kv[0] ? `url(${kv[0]})` : ""}}>
          <div className="container">
            <div className="heading">
              <div className="main">{lang.heading.main}</div>
              <div className="sub">{lang.heading.sub}</div>
              <div className="btn-block">
                <Link
                  className="mt-button blue"
                  to={`/${props.locale}/case`}
                >{lang.case}</Link>
                <Link
                  className="mt-button green"
                  to={`/${props.locale}/contact`}
                ><span className="ion-ios-telephone" />
                  {lang.contact}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container" style={{
          paddingTop: "30px"
        }}>
          <YouTube
            style={{
              paddingTop: "10px"
            }}
            videoId="FANUDXw8KQY"
            opts={{
              width: '100%',
              height: '440px',
              playerVars: {
                rel: 0,
                showinfo: 0,
              }
            }}
          />
        </div>
        <div className="features-block">
          <div className="container">
            <div className="row">
              {lang.features.map((feature, i) =>
                <div className="col-md-4 item" key={`feature-${i}`}>
                  <div className="title">{feature.title}</div>
                  <div className="text">{feature.text}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="kv" style={{backgroundImage: kv[1] ? `url(${kv[1]})` : ""}}>
          <div className="container">
            <div className="heading">
              <div className="main">{lang.teamBlock.main}</div>
              <div className="sub">{lang.teamBlock.sub}</div>
              <div className="btn-block">
                <Link
                  className="mt-button blue"
                  to={`/${props.locale}/team`}
                >{lang.team}</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="team-block">
          <div className="container">
            {lang.teamBlock.member.map((props, i) =>
              <Member key={`member-${i}`} {...props} />
            )}
          </div>
        </div>
        <div className="case-block" ref={elem => this.caseBlock = elem}>
          <div className="container">
            <div className="row">
              {this.state.typeList.map((props, i) =>
                <div className="col-md-4 item" key={`case-${i}`}>
                  <Case {...props} />
                </div>
              )}
            </div>
            <Link
              className="mt-button blue"
              to={`/${props.locale}/case`}
            >{lang.case}
            </Link>
          </div>
        </div>
        <div className="kv" style={{backgroundImage: kv[2] ? `url(${kv[2]})` : ""}}>
          <div className="container">
            <div className="heading">
              <div className="main">{lang.methodBlock.main}</div>
              <div className="sub">{lang.methodBlock.sub}</div>
            </div>
          </div>
        </div>
        <div className="method-block">
          <div className="container">
            <div className="row">
              {lang.methodBlock.method.map((props, i) =>
                <div
                  key={`method-${i}`}
                  className={`col-md-4 item`}
                >
                  <div
                    className={`method ${props.code}`}
                    style={{
                      backgroundImage: `url(${method[i]})`
                    }}
                  >
                    <div className="heading">{props.heading}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </HFBlock>
    );
  }
}

export default HomePage;

HomePage.propTypes = {
  locale: PropTypes.string,
};

HomePage.defaultProps = {
  locale: "",
};



// WEBPACK FOOTER //
// ./src/pages/HomePage/index.js